export default {
  oneTime: {
    en: 'One-time purchase',
  },
}
